export enum ModalSize {
  X_SMALL = '400px',
  SMALL = '500px',
  MEDIUM = '600px',
  LARGE = '800px',
  M_LARGE = '900px',
  X_LARGE = '1104px'
}
